type TwitterIconProps = {
  className?: string;
  width?: string | number;
  height?: string | number;
};

export const TwitterIcon = (props: TwitterIconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 20L12.1787 8.34364L12.1921 8.35455L19.2441 0H16.8875L11.1427 6.8L6.5807 0H0.400178L7.70209 10.8827L7.7012 10.8818L0 20H2.3566L8.74344 12.4345L13.8195 20H20ZM5.64695 1.81818L16.6207 18.1818H14.7532L3.77056 1.81818H5.64695Z"
      fill="currentColor"
    />
  </svg>
);
